// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"152":"5c2ac9a945ec02e84137","805":"34d38d8cc80d7ad798bf","845":"9a9425464d0f68359285","884":"4aad1fc4837670485aff","916":"2ff8b3a7a61e0ff0eeb0"}[chunkId] + ".js";
};